import { withNamespaces } from "react-i18next";
import React, { memo, useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "reactstrap";
import { useLocation, useHistory } from "react-router-dom";
// styles
import "./style.scss";
// components
import Tabs from "./tabs";

// Contents
import DataProtectionHardwareList from "src/modules/data-protection/pages/admin/hardware/list";
import { withRouter } from "react-router-dom";
import PageBody from "../../../components/page-body";
import PageContent from "../../../components/page-content";
import Navigator from "../../../components/navigator";
import DataProtectionHardwareService from "../../../apis/DataProtectionHardwareService";
import { useQuery } from "@tanstack/react-query";

const DataProtectionHardwareMainPage = (props) => {
  const history = useHistory();
  const location = useLocation();

  const {
    data: countData
  } = useQuery({
    queryKey: ["gdpr-fetch-hardwars-count"],
    queryFn: async () => {
      const service = DataProtectionHardwareService.getInstance();
      return await service.getCount();
    },
    refetchOnWindowFocus: false
  });

  const navigatorOptions = useMemo(() => {
    return {
        enable: true,
        backButtonOptions: {
            onClick: () => {
                const searchParams = new URLSearchParams(location.search);
                searchParams.delete("page");
                history.push(`/admin/data-protection/reports`);
            }
        },
        breadCrumbs: [
            {
                title: "Hardware Assets",
                link: `/admin/data-protection/hardwares?tab=all-hardware-assets`,
            }
        ]
    }
  }, []);

  const { t } = props;

  const renderContent = () => {
    const searchParams = new URLSearchParams(location.search);

    let result = null;

    switch (searchParams.get("tab")) {
      case "all-hardware-assets":
        result = <DataProtectionHardwareList />;
        break;

      case "deletion-protocol":
        result = <DataProtectionHardwareList />;
        break;
      default:
        break;
    }

    return (
      <React.Fragment>
        <Tabs 
            t={t} 
            totalCount={countData?.data?.all || 0} 
            deletedCount={countData?.data?.deleted || 0} 
        />

        {result}
      </React.Fragment>
    );
  };

  return (
    <PageContent classNames="data-protection-software-details-page software-details-page">
      <Container fluid>
        {/* page header */}
        <Row>
          {navigatorOptions.enable && (
            <Col lg="12" className="mb-4">
              <Navigator
                backButtonOptions={(props) => {
                  return {
                    ...props,
                    ...navigatorOptions.backButtonOptions,
                  };
                }}
                breadCrumbs={navigatorOptions.breadCrumbs}
              />
            </Col>
          )}
        </Row>

        {/* page body */}
        <PageBody classNames="p-0">
          <div className="details-content-wrapper">{renderContent()}</div>
        </PageBody>
      </Container>
    </PageContent>
  );
};

export default withNamespaces()(
  withRouter(memo(DataProtectionHardwareMainPage))
);
